import React from "react";
import {
    RatingBlock,
    RatingFullBlock,
    ReviewBar,
    ReviewFillBar,
    ReviewLoadBar,
    ReviewProgress,
    ReviewSection,
    ReviewSectionContent,
    ReviewStarProgress,
    StarReviewBox,
    StarReviewList,
    StarReviewSection,
    Tooltip,
    TooltipIcon,
    TooltipText,
    ToolTipWrapper,
} from "./Styled";
import PropTypes from "prop-types";

const ReviewSummary = (props) => {
    const {makeVerticalRatingStyle = false} = props;
    const reviewImageWidth = 82.8,
        starTotalWidth = 70.64;
    //const leftImagePadding=5,rightImagePadding=6.4;
    const singleStartArea = (starTotalWidth / (reviewImageWidth * 5)) * 100,
        singleSpaceArea = ((reviewImageWidth - starTotalWidth) / (reviewImageWidth * 4)) * 100;
    const {counsellingRatingData, avgRatingDisplayOrder, starRatingDisplayOrder} = props.data;
    const toolTipText = {
        guidanceRating: "Indicates how well the counselor guided students.",
        knowledgeRating:
            "Indicates counselors understanding on country, courses, applications & visa procedure.",
        responseRating: "Indicates counselor getting back to students as per requirements.",
    };
    return (
        <ReviewSection makeVerticalRatingStyle={makeVerticalRatingStyle}>
            <ReviewSectionContent>
                <StarReviewSection makeVerticalRatingStyle={makeVerticalRatingStyle}>
                    <ReviewProgress>
                        {Object.keys(starRatingDisplayOrder).map(function (key, index) {
                            return (
                                <ReviewBar
                                    makeVerticalRatingStyle={makeVerticalRatingStyle}
                                    key={`reviewBar${index}`}
                                    className={
                                        counsellingRatingData.starRatingAggregationMap[key] === 0 &&
                                        `disabled`
                                    }
                                >
                                    <strong>{starRatingDisplayOrder[key]}</strong>
                                    <ReviewLoadBar
                                        makeVerticalRatingStyle={makeVerticalRatingStyle}
                                    >
                                        <ReviewFillBar
                                            width={
                                                counsellingRatingData.starRatingAggregationMap[key]
                                            }
                                            makeVerticalRatingStyle={makeVerticalRatingStyle}
                                        />
                                    </ReviewLoadBar>
                                    <ReviewStarProgress>
                                        {counsellingRatingData.starRatingAggregationMap[key]}%
                                    </ReviewStarProgress>
                                </ReviewBar>
                            );
                        })}
                    </ReviewProgress>
                </StarReviewSection>
                <StarReviewSection makeVerticalRatingStyle={makeVerticalRatingStyle}>
                    {Object.keys(avgRatingDisplayOrder).map(function (key, index) {
                        const rating = counsellingRatingData.ratingAggregMap[key];
                        const noOfSpaces = Math.ceil(rating) > 1 ? Math.ceil(rating) - 1 : 0;
                        return (
                            <StarReviewBox
                                key={`reviewbox${index}`}
                                makeVerticalRatingStyle={makeVerticalRatingStyle}
                            >
                                <label>
                                    {avgRatingDisplayOrder[key]}
                                    <ToolTipWrapper>
                                        <span className="infoIcon">&#9432;</span>
                                        <Tooltip makeVerticalRatingStyle={makeVerticalRatingStyle}>
                                            <TooltipIcon
                                                makeVerticalRatingStyle={makeVerticalRatingStyle}
                                            />
                                            <TooltipText>{toolTipText[key]}</TooltipText>
                                        </Tooltip>
                                    </ToolTipWrapper>
                                </label>
                                <StarReviewList>
                                    <span>{counsellingRatingData.ratingAggregMap[key]}</span>
                                    <RatingBlock>
                                        <RatingFullBlock
                                            width={
                                                rating * singleStartArea +
                                                noOfSpaces * singleSpaceArea
                                            }
                                        />
                                    </RatingBlock>
                                </StarReviewList>
                            </StarReviewBox>
                        );
                    })}
                </StarReviewSection>
            </ReviewSectionContent>
        </ReviewSection>
    );
};

ReviewSummary.propTypes = {
    data: PropTypes.object,
    makeVerticalRatingStyle: PropTypes.bool,
};
export default ReviewSummary;
